import React from 'react';

import { TableDataItem, ThConfig } from '../types';
import { getWidthStyles } from '../helpers';
import cls from '../Table.module.scss';
import Tooltip from 'src/components/UI/Tooltip/Tooltip';
interface IProps {
  tableDataItem: TableDataItem;
  thConfig: ThConfig;
  thConfigIndex: number;
}
const TableDataElement = ({
  tableDataItem,
  thConfig,
  thConfigIndex,
}: IProps) => {
  const findedData = tableDataItem.elements[thConfig.columnId];
  const tdStyles: any = getWidthStyles(thConfig);
  if (findedData.xAlign && !findedData.element && !findedData.afterElement) {
    tdStyles.textAlign = findedData.xAlign;
  }

  if (findedData.yAlign && !findedData.element && !findedData.afterElement) {
    tdStyles.verticalAlign = findedData.yAlign;
  }
  return (
    <td
      key={thConfig.columnId}
      style={tdStyles}
      {...(findedData?.className ? { className: findedData.className } : {})}
    >
      {findedData.element || findedData.afterElement ? (
        <div
          className={`${cls['td-block-wrapper']} ${findedData.innerClassName}`}
          style={{
            justifyContent: findedData.xAlign,
            alignItems: findedData.yAlign,
          }}
        >
          {findedData.element}
          {findedData.text ? (
            <div className="td-text">
              {findedData.enableTooltip && findedData.text ? (
                <Tooltip className="table-tooltip" message={findedData.text}>
                  {findedData.text}
                </Tooltip>
              ) : (
                findedData.text
              )}
            </div>
          ) : null}
          {findedData.afterElement}
        </div>
      ) : (
        <span>
          {findedData.enableTooltip && findedData.text ? (
            <Tooltip className="table-tooltip" message={findedData.text}>
              {findedData.text}
            </Tooltip>
          ) : (
            findedData.text
          )}
        </span>
      )}
    </td>
  );
};

export default TableDataElement;
